<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    class="green-next-button"
    :class="classes"
    :disabled="disabled || loading"
    @click="clickHandler"
  >
    <SpinLoader v-if="loading" class="green-next-button__spin" size="xl" current-color />
    <div class="green-next-button__content">
      <span class="close-icon" v-if="type === 'close'"></span>
      <span class="edit-icon" v-if="type === 'edit'"></span>
      <span class="done-icon" v-if="type === 'done'"></span>
      <span class="redact-icon" v-if="type === 'redact'"></span>
      <span class="file-icon" v-if="type === 'file'"></span>
      {{ text }}
      <slot></slot>
      <span v-if="type === 'next'" class="next-icon"></span>
      <span v-if="type === 'plus'" class="plus-icon"></span>
    </div>
  </component>
</template>

<script>
import SpinLoader from '@/components/widgets/simple-components/spin/SpinLoader'

export default {
  name: 'nextButton',
  components: { SpinLoader },
  props: {
    color: {
      type: String,
      default() {
        return 'green'
      }
    },
    type: {
      type: String,
      default() {
        return 'next'
      }
    },
    text: {
      type: String
    },
    disabled: Boolean,
    loading: Boolean,
    to: [String, Object]
  },
  computed: {
    classes() {
      return [this.color, { loading: this.loading }]
    }
  },
  mounted() {},
  methods: {
    clickHandler() {
      this.$emit('clickHandler')
    }
  }
}
</script>

<style lang="scss" scoped>
.green-next-button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;
  padding: 20px 40px;
  font-size: 16px;
  color: white;
  line-height: 20px;
  white-space: nowrap;
  text-shadow: 1px 1px 0px rgba(3, 136, 134, 0.5);
  background: url('@/assets/images/background_line.png'), linear-gradient(180deg, #37c389 0%, #00cccc 100%);
  background-blend-mode: multiply, normal;
  background-size: cover;
  border-radius: 3px;
  border: none;
  box-sizing: border-box;

  &:hover {
    color: white;
    text-decoration: none;
  }

  &:disabled:not(.loading) {
    opacity: 0.45;
    cursor: default;
    pointer-events: none;
  }

  &.loading {
    cursor: default;
    pointer-events: none;

    .green-next-button__content {
      opacity: 0;
    }
  }

  &__content {
    display: flex;
    align-items: center;
  }

  &__spin {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}

// COLORS
.green-next-button {
  &.white {
    border: 1px solid #1cc8ab;
    background: white;
    color: #1cc8ab;
    text-shadow: none;

    &.inactive {
      background-color: #ffffff;
      border: 1px solid #cccccc;
      background-image: none;
      color: #cccccc;
      text-shadow: none;

      .close-icon {
        background-image: url("data:image/svg+xml,%3Csvg width='10' height='12' viewBox='0 0 10 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.02638 10.756L4.79689 7.36501L1.56837 10.756C1.39635 10.9325 1.16437 11.0301 0.923842 11.0287C0.683318 11.0273 0.453362 10.9263 0.283217 10.7478C0.113072 10.5693 0.0171601 10.3277 0.0156392 10.0751C0.0141184 9.82257 0.107423 9.58014 0.275405 9.39938L3.50392 6.00842L0.275405 2.61848C0.18891 2.52972 0.119512 2.42366 0.0722799 2.30676C0.0250476 2.18985 0.000685404 2.06358 1.42519e-05 1.93659C-0.0006569 1.80961 0.02238 1.68387 0.0683736 1.56643C0.114367 1.44898 0.182041 1.34242 0.267592 1.25266C0.353144 1.1629 0.454531 1.09168 0.56642 1.04348C0.67831 0.995274 0.798997 0.970896 0.919936 0.971699C1.04087 0.972502 1.1602 0.998919 1.2715 1.0486C1.3828 1.09829 1.48391 1.171 1.56837 1.26188L4.79689 4.65183L8.02638 1.26188C8.1984 1.08536 8.42941 0.986704 8.66993 0.988105C8.91046 0.989507 9.14041 1.09055 9.31056 1.26906C9.4807 1.44758 9.57759 1.68917 9.57911 1.94172C9.58064 2.19427 9.48733 2.43772 9.31935 2.61848L6.08986 6.00842L9.31935 9.39938C9.48733 9.58014 9.58064 9.82257 9.57911 10.0751C9.57759 10.3277 9.4807 10.5693 9.31056 10.7478C9.14041 10.9263 8.91046 11.0273 8.66993 11.0287C8.42941 11.0301 8.1984 10.9325 8.02638 10.756Z' fill='%23CCCCCC'/%3E%3C/svg%3E%0A");
      }
    }
  }

  &.red {
    border: 1px solid #d65959;
    background: white;
    color: #d65959;
    text-shadow: none;

    .close-icon {
      background-image: url("data:image/svg+xml,%3Csvg width='10' height='12' viewBox='0 0 10 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.02638 10.756L4.79689 7.36501L1.56837 10.756C1.39635 10.9325 1.16437 11.0301 0.923842 11.0287C0.683318 11.0273 0.453362 10.9263 0.283217 10.7478C0.113072 10.5693 0.0171601 10.3277 0.0156392 10.0751C0.0141184 9.82257 0.107423 9.58014 0.275405 9.39938L3.50392 6.00842L0.275405 2.61848C0.18891 2.52972 0.119512 2.42366 0.0722799 2.30676C0.0250476 2.18985 0.000685404 2.06358 1.42519e-05 1.93659C-0.0006569 1.80961 0.02238 1.68387 0.0683736 1.56643C0.114367 1.44898 0.182041 1.34242 0.267592 1.25266C0.353144 1.1629 0.454531 1.09168 0.56642 1.04348C0.67831 0.995274 0.798997 0.970896 0.919936 0.971699C1.04087 0.972502 1.1602 0.998919 1.2715 1.0486C1.3828 1.09829 1.48391 1.171 1.56837 1.26188L4.79689 4.65183L8.02638 1.26188C8.1984 1.08536 8.42941 0.986704 8.66993 0.988105C8.91046 0.989507 9.14041 1.09055 9.31056 1.26906C9.4807 1.44758 9.57759 1.68917 9.57911 1.94172C9.58064 2.19427 9.48733 2.43772 9.31935 2.61848L6.08986 6.00842L9.31935 9.39938C9.48733 9.58014 9.58064 9.82257 9.57911 10.0751C9.57759 10.3277 9.4807 10.5693 9.31056 10.7478C9.14041 10.9263 8.91046 11.0273 8.66993 11.0287C8.42941 11.0301 8.1984 10.9325 8.02638 10.756Z' fill='%23d65959'/%3E%3C/svg%3E%0A");
    }
  }

  &.gray {
    border: 1px solid #333;
    background: white;
    color: #333;
    text-shadow: none;

    &:hover {
      background: #f2f5f8;
    }

    span[class*='-icon'] {
      display: none;
    }
  }
}

.button {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.green-next-button span.file-icon {
  width: 10px;
  height: 12px;
  margin-left: 0;
  margin-right: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='13' viewBox='0 0 11 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_1415_2142)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 5.46368L9.9585 5.50519L10 5.50519L10 10.0052L10 11.0052L-4.37597e-07 11.0052L-1.34756e-06 10.0052L-4.41942e-08 2.00519L-4.82844e-10 1.00519L5.5 1.00519L5.5 1.0246L5.53046 0.99414L10 5.46368ZM1 10.0052L9 10.0052L9 6.50519L4.5 6.50519L4.5 5.50519L5.5 5.50519L8.62729 5.50519L5.5 2.3779L5.5 5.50519L4.5 5.50519L4.5 2.00519L1 2.00519L1 10.0052Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1415_2142' x='0' y='0.994141' width='11' height='11.0107' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_1415_2142'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1415_2142' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A");
}

.green-next-button span.redact-icon {
  width: 10px;
  height: 10px;
  margin-left: 0;
  margin-right: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.10593 6.93866C3.15073 6.98113 3.17558 6.98113 3.2191 6.93866C3.34314 6.82097 3.46833 6.7045 3.59353 6.58803L3.59354 6.58801C3.69016 6.49813 3.78677 6.40824 3.88286 6.31779C4.59248 5.64894 5.30175 4.9798 6.01067 4.31038C6.87105 3.49785 7.73114 2.68503 8.59096 1.87193C8.59915 1.86425 8.60789 1.8574 8.61839 1.84916L8.6184 1.84915L8.62642 1.84284L8.60902 1.82396C8.59859 1.81256 8.58927 1.80237 8.57949 1.79273C7.99685 1.21051 7.41448 0.627863 6.8324 0.0447917C6.78866 0.000838415 6.7687 0.00784547 6.72942 0.0471274C6.04995 0.717114 5.36998 1.38618 4.68952 2.05433C3.6253 3.10538 2.56122 4.15672 1.49728 5.20835C1.45121 5.25357 1.44484 5.27799 1.49367 5.32789C2.02479 5.87147 2.56221 6.40839 3.10593 6.93866ZM9.16374 8.67583H9.16372C9.12879 8.67595 9.09389 8.67606 9.05916 8.67547C8.69628 8.66931 8.37268 8.41685 8.28838 8.06331C8.27377 8.00209 8.26781 7.93883 8.26185 7.87556C8.25819 7.83678 8.25454 7.798 8.24889 7.75967C8.20409 7.45518 7.941 7.21928 7.63928 7.21078C7.30825 7.20144 7.03115 7.41271 6.97169 7.72761C6.96209 7.77833 6.95929 7.83036 6.95648 7.8824V7.88241C6.95377 7.93277 6.95106 7.98313 6.94218 8.03231C6.87169 8.42152 6.55042 8.68014 6.1523 8.67483C5.77731 8.66974 5.43609 8.3731 5.37961 7.99961C5.3736 7.96023 5.37113 7.92021 5.36867 7.88022C5.36547 7.82836 5.36228 7.77657 5.35137 7.72633C5.27918 7.39382 4.97745 7.17957 4.63729 7.21227C4.31879 7.24285 4.06993 7.52058 4.06186 7.85479C4.0504 8.33064 3.69601 8.67483 3.21762 8.67483C2.36828 8.67483 1.52 8.67483 0.671089 8.67695C0.593623 8.67707 0.516635 8.6891 0.442829 8.71263C0.131121 8.81412 -0.0421437 9.1116 0.00881659 9.44646C0.0553179 9.75307 0.333052 9.97963 0.675972 9.98069C1.52531 9.98338 2.37415 9.98388 3.2225 9.98218C3.57052 9.98218 3.90558 9.91402 4.21092 9.74479C4.33302 9.67725 4.4484 9.59778 4.5645 9.51782C4.6174 9.48139 4.67045 9.44485 4.72435 9.4093C5.49533 10.1353 6.77083 10.2075 7.62293 9.4093L7.63362 9.41721C7.64117 9.4227 7.6488 9.42824 7.65584 9.43457C8.15843 9.88832 8.75828 10.0304 9.41545 9.97241C9.74967 9.94289 9.98876 9.67514 9.9998 9.34029C10.0036 9.18701 9.95241 9.03743 9.8554 8.91869C9.7584 8.79995 9.62205 8.71991 9.47109 8.69309C9.37093 8.67515 9.26721 8.67549 9.16374 8.67583ZM0.106506 8.18293C0.372137 7.35653 0.633946 6.54902 0.915926 5.73047C1.53743 6.33817 2.14046 6.94545 2.74731 7.57099L0.106506 8.18293Z' fill='%231CC8AB'/%3E%3C/svg%3E%0A");
}

.green-next-button span.plus-icon {
  width: 12px;
  height: 12px;
  margin-right: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_1495_126)'%3E%3Cpath d='M4.58462 10.5795V6.76089H0.765965C0.5685 6.75414 0.381913 6.67027 0.244612 6.52818C0.107311 6.3861 0.0305466 6.19682 0.0305467 5.99924C0.0305468 5.80165 0.106621 5.61168 0.243922 5.4696C0.381223 5.32752 0.5685 5.24434 0.765965 5.23758L4.58047 5.23343L4.58047 1.41478C4.58265 1.21361 4.66382 1.02166 4.80697 0.880308C4.95012 0.738955 5.14372 0.659654 5.3449 0.660027C5.54607 0.6604 5.7395 0.740497 5.88213 0.882379C6.02476 1.02426 6.10513 1.21637 6.10655 1.41754L6.10655 5.2362L9.92521 5.2362C10.1227 5.24295 10.31 5.32613 10.4473 5.46822C10.5846 5.6103 10.6606 5.80027 10.6606 5.99785C10.6606 6.19544 10.5839 6.38472 10.4466 6.5268C10.3093 6.66888 10.1227 6.75275 9.92521 6.75951H6.10655L6.10655 10.5782C6.10689 10.6783 6.0867 10.777 6.04855 10.8696C6.0104 10.9621 5.95499 11.046 5.8842 11.1168C5.81342 11.1876 5.72885 11.2437 5.6363 11.2818C5.54375 11.32 5.445 11.3402 5.3449 11.3398C5.24499 11.3406 5.14589 11.3212 5.05349 11.2832C4.96109 11.2452 4.87743 11.189 4.80697 11.1182C4.73638 11.0473 4.68003 10.9627 4.64193 10.8703C4.60384 10.7778 4.58441 10.6795 4.58462 10.5795Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1495_126' x='0.0305176' y='0.660156' width='11.6301' height='11.6797' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_1495_126'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1495_126' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A");
}

.green-next-button span.done-icon {
  width: 11px;
  margin-left: 0;
  margin-right: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='9' viewBox='0 0 11 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_1144_4987)'%3E%3Cpath d='M8.57798 0.750945C8.7445 0.588613 8.95253 0.500001 9.16709 0.500001C9.38166 0.500001 9.58968 0.588613 9.7562 0.750945C9.83224 0.823422 9.89365 0.915558 9.93586 1.02048C9.97808 1.1254 10 1.24041 10 1.35691C10 1.47342 9.97808 1.58842 9.93586 1.69335C9.89365 1.79827 9.83224 1.8904 9.7562 1.96288L4.58942 7.24906C4.4229 7.41139 4.21488 7.5 4.00031 7.5C3.78575 7.5 3.57772 7.41139 3.4112 7.24906L0.243798 4.36275C0.167764 4.29028 0.106351 4.19814 0.0641378 4.09322C0.0219243 3.9883 -6.36618e-07 3.87329 -6.26432e-07 3.75679C-6.16247e-07 3.64028 0.0219244 3.52528 0.0641378 3.42035C0.106351 3.31543 0.167764 3.2233 0.243798 3.15082C0.410319 2.98849 0.618343 2.89987 0.832907 2.89987C1.04747 2.89987 1.2555 2.98849 1.42202 3.15082L4.00031 5.43115L8.57798 0.750945Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1144_4987' x='0' y='0.5' width='11' height='8' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_1144_4987'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1144_4987' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A");
}

.green-next-button span.edit-icon {
  width: 11px;
  margin-left: 0;
  margin-right: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 1.41397L5.86549 5.54848L4.45128 4.13427L8.58579 -0.000244141L10 1.41397ZM2 2.18302e-05V-4.74751e-05L0 -4.75625e-05V2.18302e-05V2.00002V8.00002V9.99995V10H10L10 9.99995L10 8.00002L10 3.99995L8 5.99995V8.00002H2L2 2.00002H4L6 2.18302e-05H2ZM3.28274 6.79294L5.35 6.13989L3.93579 4.72568L3.28274 6.79294Z' fill='%231CC8AB'/%3E%3C/svg%3E%0A");
}

.green-next-button span.close-icon {
  width: 11px;
  margin-left: 0;
  margin-right: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='12' viewBox='0 0 10 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.02638 10.7557L4.79689 7.36477L1.56837 10.7557C1.39635 10.9323 1.16437 11.0299 0.923842 11.0285C0.683318 11.0271 0.453362 10.926 0.283217 10.7475C0.113072 10.569 0.0171601 10.3274 0.0156392 10.0749C0.0141184 9.82232 0.107423 9.5799 0.275405 9.39914L3.50392 6.00817L0.275405 2.61823C0.18891 2.52948 0.119512 2.42342 0.0722799 2.30651C0.0250476 2.18961 0.000685404 2.06333 1.42519e-05 1.93635C-0.0006569 1.80936 0.02238 1.68363 0.0683736 1.56618C0.114367 1.44873 0.182041 1.34217 0.267592 1.25241C0.353144 1.16265 0.454531 1.09143 0.56642 1.04323C0.67831 0.99503 0.798997 0.970652 0.919936 0.971455C1.04087 0.972258 1.1602 0.998675 1.2715 1.04836C1.3828 1.09804 1.48391 1.17075 1.56837 1.26164L4.79689 4.65158L8.02638 1.26164C8.1984 1.08512 8.42941 0.986459 8.66993 0.987861C8.91046 0.989263 9.14041 1.0903 9.31056 1.26882C9.4807 1.44733 9.57759 1.68892 9.57911 1.94147C9.58064 2.19402 9.48733 2.43747 9.31935 2.61823L6.08986 6.00817L9.31935 9.39914C9.48733 9.5799 9.58064 9.82232 9.57911 10.0749C9.57759 10.3274 9.4807 10.569 9.31056 10.7475C9.14041 10.926 8.91046 11.0271 8.66993 11.0285C8.42941 11.0299 8.1984 10.9323 8.02638 10.7557Z' fill='%231CC8AB'/%3E%3C/svg%3E%0A");
}

.green-next-button span.next-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='11' viewBox='0 0 6 11' fill='none'%3E%3Cg filter='url(%23filter0_d_332_93)'%3E%3Cpath d='M0.209113 1.42248C0.0738297 1.25599 -1.81198e-05 1.04801 -1.81198e-05 0.833484C-1.81198e-05 0.61896 0.0738297 0.410975 0.209113 0.244484C0.269514 0.168465 0.346298 0.107064 0.433738 0.0648581C0.521179 0.0226525 0.61702 0.000732422 0.714113 0.000732422C0.811207 0.000732422 0.907047 0.0226525 0.994488 0.0648581C1.08193 0.107064 1.15871 0.168465 1.21911 0.244484L4.79111 4.41048C4.9264 4.57697 5.00024 4.78496 5.00024 4.99948C5.00024 5.21401 4.9264 5.42199 4.79111 5.58848L1.21911 9.75548C1.15871 9.8315 1.08193 9.8929 0.994488 9.93511C0.907047 9.97732 0.811207 9.99924 0.714113 9.99924C0.61702 9.99924 0.521179 9.97732 0.433738 9.93511C0.346298 9.8929 0.269514 9.8315 0.209113 9.75548C0.0738297 9.58899 -1.81198e-05 9.38101 -1.81198e-05 9.16648C-1.81198e-05 8.95196 0.0738297 8.74397 0.209113 8.57748L3.27611 4.99948L0.209113 1.42248Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_332_93' x='0' y='0.000732422' width='6.00024' height='10.9985' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.0117647 0 0 0 0 0.533333 0 0 0 0 0.52549 0 0 0 0.5 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_332_93'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_332_93' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E");
}

.green-next-button span {
  display: inline-block;
  width: 6px;
  height: 11px;
  margin-left: 9px;
  background-repeat: no-repeat;
}

.green-next-button.white .next-icon {
  display: flex;
  justify-content: space-between;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5' height='10' viewBox='0 0 5 10' fill='none'%3E%3Cpath d='M0.209128 1.42248C0.0738449 1.25599 -2.86102e-06 1.04801 -2.86102e-06 0.833484C-2.86102e-06 0.61896 0.0738449 0.410975 0.209128 0.244484C0.269529 0.168465 0.346313 0.107064 0.433753 0.0648581C0.521194 0.0226525 0.617035 0.000732422 0.714128 0.000732422C0.811222 0.000732422 0.907063 0.0226525 0.994503 0.0648581C1.08194 0.107064 1.15873 0.168465 1.21913 0.244484L4.79113 4.41048C4.92641 4.57697 5.00026 4.78496 5.00026 4.99948C5.00026 5.21401 4.92641 5.42199 4.79113 5.58848L1.21913 9.75548C1.15873 9.8315 1.08194 9.8929 0.994503 9.93511C0.907063 9.97732 0.811222 9.99924 0.714128 9.99924C0.617035 9.99924 0.521194 9.97732 0.433753 9.93511C0.346313 9.8929 0.269529 9.8315 0.209128 9.75548C0.0738449 9.58899 -2.86102e-06 9.38101 -2.86102e-06 9.16648C-2.86102e-06 8.95196 0.0738449 8.74397 0.209128 8.57748L3.27613 4.99948L0.209128 1.42248Z' fill='%231CC8AB'/%3E%3C/svg%3E");
}

.inactive.green-next-button {
  display: flex;
  align-items: center;
  background: url('@/assets/images/background_line.png'), #cccccc;
  cursor: default;
  background-size: cover;
}
</style>
